<template>
  <div id="test-questions">
    <div class="container" :class="{ done: testDone }">
      <comp-header v-if="!testDone" :headerTitle="pageTitle" />

      <div class="contents">
        <span>{{ question }}</span>
      </div>

      <div class="buttons" v-if="testDone">
        <div class="button" @click="onGoToDashboardClick">Go to Dashboard</div>
      </div>

      <div class="buttons" v-else>
        <div id="btn1" class="button" @click="performSendAnswer">
          Very Likely
        </div>
        <div id="btn2" class="button" @click="performSendAnswer">
          Somewhat Likely
        </div>
        <div id="btn3" class="button" @click="performSendAnswer">
          Somewhat Unlikely
        </div>
        <div id="btn4" class="button" @click="performSendAnswer">
          Very Unlikely
        </div>
        <div
          class="go-back"
          v-if="questionNum > 1 && isRollbackAvailable"
          @click="performRollbackAnswer"
        >
          Go Back (One time only)
        </div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import QuestionService from '@/services/question-service'
import common from '@/utils/common'
import CompHeader from '@/components/CompHeader'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'TestQuestions',
  mixins: [common],
  components: {
    CompHeader,
    CompLoading
  },
  created() {
    this.$parent.setNav(false)
    this.$parent.setHeader(null)
    this.$parent.setBottomTab(false)

    if (this.isEmpty(this.$store.state.auth.user)) {
      alert('Incorrect approach.')
      this.goBack()
    } else {
      this.performGetQuestion()
    }
  },
  data() {
    return {
      isLoading: false,

      pageTitle: '',
      isRollbackAvailable: false,

      eID: '',
      questionNum: 1,
      question: '',
      testDone: false
    }
  },
  methods: {
    padLeadingZeros(num, size) {
      var s = num + ''
      while (s.length < size) s = '0' + s
      return s
    },
    setQuestionNumber() {
      const formattedNumber = this.padLeadingZeros(this.questionNum, 3)
      this.pageTitle = `Question ${formattedNumber}`
    },
    performGetQuestion() {
      this.isLoading = true

      QuestionService.getQuestion().then(({ resultCode, resultData }) => {
        this.isLoading = false

        if (resultCode === 0) {
          if (!this.isEmpty(resultData)) {
            if (parseInt(resultData.errorCode) === 600) {
              this.finishTest()
              return
            }
            this.eID = resultData.eId
            this.question = resultData.qMent
            this.questionNum = resultData.qCnt
            this.isRollbackAvailable = parseInt(resultData.previousCount) === 0
            this.setQuestionNumber()
          }
        }
      })
    },
    performSendAnswer(event) {
      this.isLoading = true

      var priority = 1
      switch (event.target.id) {
        case 'btn1':
          priority = 1
          break
        case 'btn2':
          priority = 2
          break
        case 'btn3':
          priority = 3
          break
        case 'btn4':
          priority = 4
      }
      const answerData = {
        eId: this.eID,
        answer: priority
      }
      QuestionService.sendAnswer(answerData).then(
        ({ resultCode, resultData }) => {
          this.isLoading = false

          if (resultCode === 0) {
            if (!this.isEmpty(resultData)) {
              if (parseInt(resultData.errorCode) === 600) {
                this.finishTest()
                return
              }
              this.question = resultData.qMent
              this.questionNum = resultData.qCnt
              this.setQuestionNumber()
            }
          }
        }
      )
    },
    performRollbackAnswer() {
      if (this.isRollbackAvailable) {
        this.isLoading = true
        this.isRollbackAvailable = false

        QuestionService.rollbackAnswer().then(({ resultCode, resultData }) => {
          this.isLoading = false

          if (resultCode === 0) {
            if (!this.isEmpty(resultData)) {
              if (parseInt(resultData.errorCode) === 600) {
                this.finishTest()
                return
              }
              this.question = resultData.qMent
              this.questionNum = resultData.qCnt
              this.setQuestionNumber()
              return
            }
          }
          this.isRollbackAvailable = true
        })
      }
    },
    finishTest() {
      this.question = 'Test done.'
      this.testDone = true
    },
    onGoToDashboardClick() {
      this.goPage('dashboard')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/test-questions.scss" scoped></style>
